const getScoreColor = (score) => {
  if (!score) return '#a0a0a0';
  if (score < 45) return '#fb236a';
  if (score < 75) return '#fb9b23';
  return '#7dc246';
};

export default getScoreColor;
